import * as React from 'react';

import omit from 'lodash/omit';
import {useDispatch} from 'react-redux';
import {getUserContentSubscriptionsExternalV2} from 'src/action-creators/content-subscription';
import {useAsyncDependency} from 'src/hooks/useAsyncDependency';

import ManageSubscriptions from './manage-subscription';
import ManageSubscriptionsV2 from './manage-subscriptionV2';
import Unsubscribe from './unsubscribe';
import UnsubscribeV2 from './unsubscribeV2';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';

import css from './style.css';


const ManageSubscriptionsWrapper = ({
  params,
}: {
  params: {
    isDebugEntity?: boolean;
    sentEventId?: string;
    unsubscribeCategoryId: string | null | undefined;
    attributeValue: string | null | undefined;
    attributeName: string | null | undefined;
    entityId?: string;
    entityType?: string;
    deliveryAddress?: string;
    trackingId?: string;
  };
}) => {
  const dispatch = useDispatch();
  const subscriptionsLoading = useAsyncDependency(() => {
    if (params.trackingId) {
      return dispatch(getUserContentSubscriptionsExternalV2(params.trackingId));
    }
    return Promise.resolve();
  }, [params.trackingId]);

  const paramsV1 = omit(params, 'trackingId');
  let Component = ManageSubscriptions;
  let ComponentV2 = ManageSubscriptionsV2;

  if (params.unsubscribeCategoryId) {
    Component = Unsubscribe;
    ComponentV2 = UnsubscribeV2;
  }

  return params.sentEventId ? (
    // @ts-expect-error - TS2322 - Type 'Pick<{ isDebugEntity?: boolean | undefined; sentEventId?: string | undefined; unsubscribeCategoryId: string | null | undefined; attributeValue: string | null | undefined; attributeName: string | ... 1 more ... | undefined; entityId?: string | undefined; entityType?: string | undefined; deliveryAddress?: string | und...' is not assignable to type '{ isDebugEntity: boolean; sentEventId: string; unsubscribeCategoryId: string; attributeValue: string; attributeName: string; entityId: string; entityType: string; deliveryAddress: string; }'.
    <Component params={paramsV1} />
  ) : subscriptionsLoading ? (
    <div className={css.loaderContainer}>
      <CircularLoader colorToken="colorFillPrimary" size="medium" />
    </div>
  ) : (
    <ComponentV2
      trackingId={params.trackingId}
      unsubscribeCategoryId={params.unsubscribeCategoryId}
    />
  );
};

export default ManageSubscriptionsWrapper;
